<template>
  <div class="relative w-full overflow-x-hidden bg-[rgba(248,247,243,1)] desktop:bg-gold-primary-20 pb-8" style="min-height: 100vh;">
    <div class="absolute top-4 -right-20 w-[300px] h-[300px] desktop:hidden rounded-full" style="background: rgba(237, 164, 54, 0.3); filter: blur(100px);"></div>
    <div class="relative z-[1] flex w-full flex-col desktop:items-center desktop:pt-12 desktop:px-12 desktop:pb-12">
      <div class="w-full desktop:bg-[rgba(248,247,243,1)] desktop:rounded-3xl desktop:shadow-[0px_6px_16px_0px_rgba(13,15,21,0.08)] desktop:max-w-[1200px] desktop:flex desktop:flex-row desktop:p-[51px_40px]">
        <div class="hidden desktop:flex desktop:w-1/2 desktop:flex-col desktop:p-0 desktop:pb-0 desktop:rounded-3xl desktop:max-w-[600px] desktop:min-h-full" style="backdrop-filter: blur(200px); background: linear-gradient(to bottom, rgba(255, 255, 255, 0.8) 0%, rgba(237, 164, 54, 0.3) 100%);">
          <div class="flex flex-col min-h-full max-w-[650px] w-full mx-auto">
            <div class="mb-2 mt-[71px]">
              <h1 v-if="isPasswordRelatedPage" class="text-[32px] font-bold leading-[40px] tracking-[0%] text-center align-middle mb-4">
                <span class="text-black">{{ $t('auth.login.illustration.password.line1') }}</span><br />
                <span class="text-[rgba(237,164,54,1)]">{{ $t('auth.login.illustration.password.line2') }}</span><br />
                <span class="text-[rgba(237,164,54,1)]">{{ $t('auth.login.illustration.password.line3') }}</span>
              </h1>
              <h1 v-else class="text-[32px] font-bold leading-[40px] tracking-[0%] text-center align-middle mb-4">
                <span class="text-black">{{ $t('auth.login.illustration.default.line1') }}</span><br />
                <span class="text-[rgba(237,164,54,1)]">{{ $t('auth.login.illustration.default.line2') }}</span><br />
                <span class="text-[rgba(237,164,54,1)]">{{ $t('auth.login.illustration.default.line3') }}</span>
              </h1>
            </div>
            <div class="flex items-end justify-center overflow-hidden mt-auto">
              <img 
                src="/images/illustrations/main-signup.png" 
                class="w-full h-auto max-w-full" 
                alt="Login Illustration" 
              />
            </div>
          </div>
      </div>
        <div class="flex flex-1 flex-col desktop:w-1/2 desktop:items-center desktop:justify-start desktop:p-12 desktop:pt-0 desktop:pr-0 desktop:relative desktop:h-[600px]">
          <div class="w-full">
            <div class="px-4 py-6 desktop:px-0 desktop:py-0">
              <div class="flex flex-row items-center justify-between w-full mb-8">
                <NuxtLink to="/" class="desktop:hidden">
                  <NuxtImg src="/images/logos/logo.png" class="h-12 w-auto brightness-0" alt="Dubai Insiders Club" />
                </NuxtLink>
            <UIBaseTransition>
              <UIButton
                    v-if="shouldShowBackButton"
                id="back"
                variant="ghost"
                left-icon="arrow-big-filled-left"
                    left-icon-size="md"
                    :class="backButtonClasses"
                @click="$router.back()"
              >
                {{ $t('auth.signup.email.back') }}
              </UIButton>
            </UIBaseTransition>
            <LanguageSelector class="ml-auto" />
          </div>
          <slot />
        </div>
          </div>
        </div>
      </div>
      <div class="hidden desktop:flex mt-6 desktop:mt-8  px-4 py-6 desktop:py-0 flex-row items-center justify-center gap-2 text-[14px] font-normal leading-[140%] tracking-[0px] align-middle text-black/60">
        <a href="https://insidersofdubai.com/terms" target="_blank" class="hover:text-black">Terms&amp;Conditions</a>
        <span class="inline-block w-[1.5px] h-[22px] bg-black/60 rounded-[1px]"></span>
        <a href="https://insidersofdubai.com/privacy" target="_blank" class="hover:text-black">Privacy Policy</a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()

const getBaseRouteName = (routeName: string | null | undefined): string => {
  if (!routeName) return ''
  return routeName.replace(/___[a-z]{2}$/, '').replace(/-index$/, '')
}

const isPasswordRelatedPage = computed(() => {
  const baseName = getBaseRouteName(route.name as string)
  const path = route.path
  return baseName.includes('reset-password') || baseName === 'reset-sent' || baseName === 'reset-success' || 
         path.includes('/reset/password') || path.includes('/reset/sent') || path.includes('/reset/success')
})

const shouldShowBackButton = computed(() => {
  const baseName = getBaseRouteName(route.name as string)
  const path = route.path
  const loginRoutes = ['login', 'login-auto']
  return !loginRoutes.includes(baseName) && !path.match(/\/(login|login-auto)$/i)
})

const backButtonClasses = computed(() => {
  const baseName = getBaseRouteName(route.name as string)
  const path = route.path
  const hideOnMobileRoutes = ['login', 'login-auto', 'reset', 'reset-sent', 'reset-password', 'reset-success']
  const isHiddenOnMobile = hideOnMobileRoutes.includes(baseName) || 
                          path.match(/\/(reset|reset\/sent|reset\/password|reset\/success|login|login-auto)$/i)
  
  if (isHiddenOnMobile) {
    return '!hidden desktop:!flex fill-gold-primary-20 !text-black-100'
  }
  return 'fill-gold-primary-20 !text-black-100'
})
</script>

<style scoped></style>
